<template>
  <div>
    <div class="relative pt-44 pb-12 px-8 md:px-12 lg:px-16 xl:px-24">
      <div class="page-container">
        <div class="flex flex-wrap">
          <div class="w-full md:w-3/5 flex flex-col justify-center">
            <slot></slot>
          </div>
        </div>
        <div class="w-full md:w-2/5 ml-auto flex gap-4 flex-col items-start md:justify-end">
          <slot name="right"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>

</style>
